import axios from 'axios'
import store from '../store'
import { IProduct, IVersion, IEditProductRequest, IAddVersionRequest,
     IEditVersionRequest, IDeleteVersionRequest, IAddPatchRequest, IPatch } from '../model/ProductsState'
import Error from '../kne/error'

export default class ProductService {
    getAllProducts (): Promise<IProduct[]>{
        return new Promise((resolve, reject) => {
            axios.get("/api/product").then(res => {
                resolve(res.data as IProduct[])
            }, (err: Error) => {
                reject(err)
            })
        })
    }

    getProductById (id: number): Promise<IProduct>{
        return new Promise((resolve, reject) => {
            axios.get(`/api/product/${id}`).then(res => {
                resolve(res.data)
            }, (err: Error) => {
                reject(err)
            })
        })
    }

    editProduct (editRequest: IEditProductRequest): Promise<IProduct>{
        return new Promise((resolve, reject) => {
            axios.post("/api/product/EditProduct", editRequest).then( res =>{
                resolve(res.data)
            }, (err: Error) => {
                reject(err)
            })
        })
    }

    addVersion (addVersionRequest: IAddVersionRequest): Promise<IVersion>{
        return new Promise((resolve, reject) => {
            axios.post("/api/product/addVersion", addVersionRequest).then(res => {
                resolve(res.data)
            }, (err: Error) => {
                reject(err)
            })
        })
    }

    editVersion (editVersionRequest: IEditVersionRequest): Promise<IVersion>{
        return new Promise((resolve, reject) => {
            axios.post("/api/product/editVersion", editVersionRequest).then(res => {
                resolve(res.data)
            }, (err: Error) => {
                reject(err)
            })
        })
    }

    deleteVersion (deleteVersionRequest: IDeleteVersionRequest): Promise<boolean>{
        return new Promise((resolve, reject) => {
            axios.post("/api/product/deleteVersion", deleteVersionRequest).then(res => {
                resolve(true)
            }, (err: Error) => {
                reject(err)
            })
        })
    }

    addPatch (addPatchRequest: IAddPatchRequest, file: File): Promise<IPatch>{
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("patch", file, file.name)
            formData.append("addRequest", JSON.stringify(addPatchRequest))
            axios.post("/api/product/addPatch", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(res => {
                resolve(res.data)
            }, (err: Error) => {
                reject(err)
            })
        })
    }
}